import type { ReceiptTemplate } from '../schema';

export const quiktripTemplate: ReceiptTemplate = {
  id: 'quiktrip',
  name: 'QuikTrip Receipt',
  brand: 'QUIKTRIP',
  description: 'QuikTrip gas station receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'qt-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'QUIKTRIP',
        businessNameFontSize: 18,
        addressLines: [
          'STORE #489',
          '1200 DARK AVENUE',
          'MONSTERVILLE, OK 74012',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'qt-datetime',
      type: 'datetime',
      enabled: true,
      config: {
        alignment: 'center',
        dateTime: new Date().toISOString(), format: 'MM/DD/YYYY hh:mm A',
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'qt-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'QT KITCHENS HOT DOG', quantity: '1', price: '1.99', sku: '' },
          { id: '2', name: 'FOUNTAIN DRINK 32OZ', quantity: '1', price: '1.09', sku: '' },
          { id: '3', name: 'CHIPS LAYS', quantity: '1', price: '2.29', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'qt-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '5.37', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '0.48', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '5.85', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'qt-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'qt-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'QT REWARDS MEMBER\n\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

